/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileImage16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M6.754 8.128l3.102 3.204 1.327-1.625c.158-.193.415-.193.575 0l2.06 2.485c.37.446.159.808-.472.808H2.63c-.633 0-.82-.341-.414-.767l.105-.11 3.794-3.979c.18-.188.47-.19.64-.016zM9.5 4a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 019.5 4z"
        />
    </AccessibleSVG>
);

export default FileImage16;
